import * as enums from './enums';

export default async function (http) {
  let setting = await http.get(
    '/api/app/config/project_common_setting,point_info,common_setting,other_setting,order_setting,vip_setting,course_arrange_setting',
  );

  let otherSetting = setting.other_setting;
  let pointSetting = setting.point_info;
  // enums.CourseType.setItems(setting.common_setting.course_name);
  enums.CourseType.setItems({ 1: '普通课程', 2: '班级课程', 3: '公开课' });
  enums.ShopType.setItems(setting.common_setting.course_name);
  setting.project_common_setting.circle_module = JSON.parse(
    setting.project_common_setting.circle_module,
  );
  setting.project_common_setting.switch_question_module = parseInt(
    setting.project_common_setting.switch_question_module,
  );
  setting.project_common_setting.switch_study_module = parseInt(
    setting.project_common_setting.switch_study_module,
  );
  setting.project_common_setting.switch_vip_module = parseInt(
    setting.project_common_setting.switch_vip_module,
  );
  // setting.project_common_setting.homework_module = JSON.parse(
  //   setting.project_common_setting.homework_module,
  // );
  setting.common_setting.point_info = pointSetting;
  if (
    setting.project_common_setting.homework_module &&
    setting.project_common_setting.homework_module.is_correct_hw
  ) {
    const ary = setting.project_common_setting.homework_module.is_correct_hw.split(',');
    setting.project_common_setting.teacher_correct = ary.includes('1');
    setting.project_common_setting.assist_correct = ary.includes('2');
  }
  if (
    setting.project_common_setting.homework_module &&
    setting.project_common_setting.homework_module.is_dispatch_hw
  ) {
    const ary = setting.project_common_setting.homework_module.is_dispatch_hw.split(',');
    setting.project_common_setting.teacher_dispatch = ary.includes('1');
    setting.project_common_setting.assist_dispatch = ary.includes('2');
  }
  setting = Object.assign(
    {},
    setting.project_common_setting,
    setting.common_setting,
    otherSetting,
    setting.order_setting,
    setting.vip_setting,
    setting.course_arrange_setting,
  );
  return setting;
}
